import React from 'react'
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel'
import MarkerLabel from './MarkerLabel'

export default ({ onClick, icon, label, labelColor, location, opacity = 1 }) => (
  <MarkerWithLabel
    onClick={onClick}
    opacity={opacity}
    disabled
    position={{
      lat: parseFloat(location.latitude || location.lat),
      lng: parseFloat(location.longitude || location.lng),
    }}
    icon={icon}
    labelAnchor={{ x: 60, y: 75 }}
  >
    {
      label ? (
        <MarkerLabel bgColor={labelColor} opacity={opacity}>
          {label}
        </MarkerLabel>
      ) : <div />
    }
  </MarkerWithLabel>
)



// WEBPACK FOOTER //
// ./src/containers/mapView/components/MarkerWithLabel.js